// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Product$Showside from "./Product.bs.js";
function matchesString(condition, string) {
  switch (condition.TAG | 0) {
    case /* EqualsTo */0:
      return string === condition._0;
    case /* Contains */1:
      return string.includes(condition._0);
    case /* NotEqualsTo */2:
      return string !== condition._0;
  }
}
function matchesFloat(condition, $$float) {
  switch (condition.TAG | 0) {
    case /* EqualsTo */0:
      return $$float === condition._0;
    case /* NotEqualsTo */1:
      return $$float !== condition._0;
    case /* GreaterThan */2:
      return $$float > condition._0;
    case /* GreaterThanOrEqualsTo */3:
      return $$float >= condition._0;
    case /* LessThan */4:
      return $$float < condition._0;
    case /* LessThanOrEqualsTo */5:
      return $$float <= condition._0;
  }
}
function matchesInt(condition, $$int) {
  switch (condition.TAG | 0) {
    case /* EqualsTo */0:
      return $$int === condition._0;
    case /* NotEqualsTo */1:
      return $$int !== condition._0;
    case /* GreaterThan */2:
      return $$int > condition._0;
    case /* GreaterThanOrEqualsTo */3:
      return $$int >= condition._0;
    case /* LessThan */4:
      return $$int < condition._0;
    case /* LessThanOrEqualsTo */5:
      return $$int <= condition._0;
  }
}
function matchesArrayString(condition, array) {
  if (condition.TAG === /* Any */0) {
    var condition$1 = condition._0;
    return Belt_Array.some(array, function (param) {
      return matchesString(condition$1, param);
    });
  }
  var condition$2 = condition._0;
  return !Belt_Array.some(array, function (param) {
    return matchesString(condition$2, param);
  });
}
function matchesProduct(condition, product, variant) {
  switch (condition.TAG | 0) {
    case /* ProductTags */0:
      return matchesArrayString(condition._0.condition, product.tags);
    case /* ProductType */1:
      return matchesString(condition._0.condition, product.productType);
    case /* CustomLabels */2:
      return matchesArrayString(condition._0.condition, variant.customLabels);
    case /* ProductMetaData */3:
      var match = condition._0;
      return matchesString(match.condition, Belt_Option.getWithDefault(Product$Showside.Metadata.getMetadataAsText(product, variant, match.metadataKey), "undefined"));
    case /* ProductPrice */4:
      return matchesFloat(condition._0.condition, Product$Showside.Variant.getRealProductPurchasePrice(variant));
    case /* ProductQuantity */5:
      return matchesInt(condition._0.condition, Product$Showside.Variant.getQuantity(variant));
    case /* CompoundRule */6:
      var match$1 = condition._0;
      var op = match$1.op;
      return Belt_Array.reduce(Belt_Array.map(match$1.rules, function (rule) {
        return matchesProduct(rule, product, variant);
      }), op === /* And */0, function (acc, curr) {
        if (op) {
          if (acc) {
            return true;
          } else {
            return curr;
          }
        } else if (acc) {
          return curr;
        } else {
          return false;
        }
      });
  }
}
export { matchesString, matchesFloat, matchesInt, matchesArrayString, matchesProduct };
/* Product-Showside Not a pure module */